export class SiteResponse {
    SiteID?: string;
    SiteName?: string;
    SiteDescription?: string;
    Killswitch?: boolean;
}